import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const OPPORTUNITY_FILTER_SUFFIXES = {
  company: 'company',
  market: 'market',
  myRole: 'myRole',
  deletedRoles: 'deletedRoles',
} as const;

export const useOrganizationFilterSuffix = (
  defaultSuffix: keyof typeof OPPORTUNITY_FILTER_SUFFIXES
) => {
  const { pathname } = useLocation();

  return useMemo(() => {
    if (pathname.includes('company-vacancies')) {
      return OPPORTUNITY_FILTER_SUFFIXES.company;
    }
    if (pathname.includes('market')) {
      return OPPORTUNITY_FILTER_SUFFIXES.market;
    }
    if (pathname.includes('my-role')) {
      return OPPORTUNITY_FILTER_SUFFIXES.myRole;
    }
    if (pathname.includes('deleted-roles')) {
      return OPPORTUNITY_FILTER_SUFFIXES.deletedRoles;
    }
    return defaultSuffix ?? null;
  }, [defaultSuffix, pathname]);
};

export const getOpportunityFilterStorageKey = (
  suffix: keyof typeof OPPORTUNITY_FILTER_SUFFIXES
) => {
  return `opportunityFilters_${suffix}`;
};
